import React from 'react';
import { AccordionContent, AccordionGroup } from 'core/controls';
import { Translate, useTranslate } from 'core/translate';
import MathBoxAccordionHeader from './MathBoxAccordionHeader';
import StandardFeatures from '../components/standardFeatures/StandardFeaures';

const StandardFeaturesGroup = ({
  standardFeatures,
  loadingFeatures,
  isOpenDefault
}) => {
  const translate = useTranslate();
  const header = translate('component.common.standard.features');
  return (
    <div className="summary-standard-features">
      <AccordionGroup isOpenDefault={isOpenDefault} id="standard-features">
        <MathBoxAccordionHeader header={header} />
        <AccordionContent>
          {loadingFeatures ? (
            <span>
              <Translate value="component.common.loading" />
            </span>
          ) : (
            <StandardFeatures
              features={standardFeatures}
              analyticsKey={header}
            />
          )}
        </AccordionContent>
      </AccordionGroup>
    </div>
  );
};

StandardFeaturesGroup.defaultProps = {
  isOpenDefault: false
};

export default StandardFeaturesGroup;
